import { useState, useEffect } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useGetAccountOwner = ({leadID}) => {
    const [accountOwner, setAccountOwner] = useState(null)


    useEffect(() => {
        if (!leadID) return;
        const fetchData = async() => {
            try{
                const queryParams = new URLSearchParams({
                    lead_id: leadID
                })
                const result = await apiRequest(`${API_ENDPOINTS.AUTH.GET_ACCOUNT_OWNER}?${queryParams.toString()}`, 'GET')
                if (result === true) {
                    setAccountOwner(true)
                } else {
                    setAccountOwner(false)
                }
            } catch (error) {
                console.error(error)
            }
        }
        fetchData()
    }, [leadID])
    
    return accountOwner
}
